import React, { useState } from 'react';

import { t } from '../common/LocalizationProvider';
import { useEffectAsync } from '../reactHelper';
import EditCollectionView from '../EditCollectionView';
import SettingsDrawer from "../shared/SettingsDrawer";
import MainToolbar from '../MainToolbar';

import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  CssBaseline,
  useTheme,
  useMediaQuery,
  Container
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {cyberStyles} from "../cssShared/cyberTheme";

const useTableStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));

const usePageStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));

const GroupsView = ({ updateTimestamp, onMenuClick }) => {
  const classes = useTableStyles();
  const [items, setItems] = useState([]);

  useEffectAsync(async () => {
    const response = await fetch('/api/groups');
    if (response.ok) {
      setItems(await response.json());
    }
  }, [updateTimestamp]);

  return (
      <TableContainer className={classes.container}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell + ' ' + classes.columnAction} />
              <TableCell className={classes.headerCell}>{t('sharedName')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
                <TableRow key={item.id} className={classes.row}>
                  <TableCell className={classes.columnAction} padding="none">
                    <IconButton onClick={(event) => onMenuClick(event.currentTarget, item.id)}>
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell style={{ fontWeight: 500 }}>{item.name}</TableCell>
                </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
  );
}

const GroupsPage = () => {
  const classes = usePageStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [hideDrawer, setHideDrawer] = useState(() => localStorage.getItem('hideDrawer') === 'true');

  return (
      <div className={classes.settingRoot}>
        <CssBaseline />

        {!isMobile && <div className={classes.appBarWrapper}>
          <MainToolbar/>
        </div>}

        <SettingsDrawer
            hideDrawer={hideDrawer}
            setHideDrawer={setHideDrawer}
            page={'settings'}
        />

        <main className={classes.content}>
          <div className={classes.toolbarSpacer} />
          <Container maxWidth="xl">
            <EditCollectionView
                content={GroupsView}
                editPath="/settings/group"
                endpoint="groups"
            />
          </Container>
        </main>
      </div>
  );
}

export default GroupsPage;